import styled from 'styled-components';

export const CarouselContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  padding-bottom: 60px;
  position: relative;
  justify-content: center;
  .swiper-slide {
    display: flex;
    align-items: center;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  z-index: 1;
`;

export const CarouselCaption = styled.span`
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
  color: ${({ theme }) => theme.white};
  text-align: center;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  font-weight: bold;
  z-index: 2;
`;
